const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={13}
    className={`${
      props.className ? props.className : 'fill-blue hover:fill-white'
    }`}
  >
    <path d="M1.707 6.293A1 1 0 0 0 .293 7.707l5 5a1 1 0 0 0 1.414 0l11-11A1 1 0 0 0 16.293.293L6 10.586 1.707 6.293Z" />
  </svg>
);
export default CheckIcon;
